import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getTestimonial } from "../../store/actions/testimonials_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/testimonials_enum";
import SingleView from "../../components/common/SingleView";
const ViewTestimonial = ({
  getTestimonial,
  match,
  testimonial: { loading, testimonial },
}) => {
  useEffect(() => {
    getTestimonial(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          testimonial && (
            <SingleView
              data={testimonial}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={testimonial.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ testimonial: state.testimonial });

const mapDispatchToProps = { getTestimonial };

export default connect(mapStateToProps, mapDispatchToProps)(ViewTestimonial);
